import { h } from 'preact'
import ButtonControl from '../button-control'

type Props = {
  isLoading: boolean,
  onSaveChanges: () => void,
  onCancel: () => void
}

const TeamNotesButtons = ({ isLoading, onSaveChanges, onCancel }: Props) =>
  <div class='team-notes__buttons'>
    <ButtonControl
      variant='success'
      title='Save changes'
      isLoading={isLoading}
      onClick={onSaveChanges}
      class='qa-save-notes'
    />
    <ButtonControl
      title='Cancel'
      onClick={onCancel}
    />
  </div>

export default TeamNotesButtons
